export default {
  /**
   * 'a,b,c' -> ['a','b','c']
   */
  getKeys: (str) => {
    return str.split(',')
  },
  /**
   * ['a','b','c'] -> 'a,b,c'
   */
  keysToStr: (arr) => {
    return arr.joni(',')
  },
  orderStatus: {
    'NOT_PAY': '未支付',
    'NOT_CONSUME': '未消费',
    'CONSUMED': '已消费',
    'REFUNDING': '退款中',
    'CANCELED': '已取消',
    'REFUND': '已退款',
    'COMMENTED': '已评价',
    'CLOSED': '已关闭'
  },
  rechargeKind: {
    label: '充值来源',
    values: {
      0: '普通',
      1: '现金',
      2: '餐补',
      3: '微信',
      4: '支付宝',
      6: '赠送',
      8: '农行掌银'
    }
  },
  rechargeType: {
    label: '充值类型',
    values: {
      '-1': '冲红',
      1: '充值',
      2: '冲正',
      3: '月底清零'
    }
  },
  payType: {
    'alipay': '支付宝',
    'weixinpay': '微信支付',
    'common': '公司卡支付',
    'unkonwn': '暂无'
  },
  tagType: {
    label: '标签基本类型',
    values: {
      1: '普通标签',
      2: '营养标签'
    }
  },
  limitType: {
    label: '标签限制提醒类型',
    values: {
      0: '无限制无提醒',
      1: '限制',
      3: '提醒'
    }
  },
  checkType: {
    label: '标签范围',
    values: {
      1: '单品',
      2: '范围'
    }
  },
  supportMode: {
    label: '配送方式',
    values: {
      'common': '食堂就餐',
      'pickup': '食堂自提',
      'distribution': '配送上门'
    }
  },
  orderMode: {
    'common': '堂食',
    'distribution': '配送',
    'pickup': '自提'
  }
}



// WEBPACK FOOTER //
// ./src/pg/resource.js